<template>
  <section
    :class="{
      'flex w-full flex-col gap-30px lg:flex-row': true,
    }"
    data-testid="ColumnsCardsSection"
  >
    <div
      v-for="(column, index) in columns"
      :key="index"
      :class="{
        'w-full lg:w-1/2': true,
      }"
    >
      <h2
        :class="{
          'mb-10px mt-9 text-center text-2xl font-extrabold uppercase leading-7 text-www-color-neutral-medium-dark lg:text-left': true,
        }"
      >
        {{ column.title }}
      </h2>
      <p
        :class="{
          'mb-0 h-10 text-center text-13px font-semibold leading-4 text-www-color-neutral-medium-dark lg:text-left': true,
        }"
      >
        {{ column.description }}
      </p>
      <div :class="{ 'flex flex-col': true }">
        <CustomerHomeCard
          v-for="(card, cardIndex) in column.cards"
          :key="cardIndex"
          v-bind="card"
          :class="{
            'customer-home-card': true,
          }"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import CustomerHomeCard from '~/features/CustomerHome/CustomerHomeCard.vue';
import type { CustomerHomeCard as CustomerHomeCardType } from '~/sanity/types';

interface Column {
  title?: string;
  description?: string;
  cards?: ({
    _key: string;
  } & CustomerHomeCardType)[];
}

defineProps<{
  columns: Column[];
}>();
</script>
<style>
.customer-home-card a {
  width: 100%;
}
</style>
